import { type TextFieldProps, useTheme } from '@themenu/design-system'

/**
 * Custom style for inputs to prevent the browser/password managers from changing the background color
 *
 * @param props - TextFieldProps to get the disabled state
 */
export const autoFillInputStyle = (props: TextFieldProps) => {
  const theme = useTheme()

  return {
    WebkitTextFillColor: props.disabled ? theme.colors.content.disabled : theme.colors.content.default,
    WebkitBoxShadow: '0 0 0 1000px transparent inset',
    transition: 'background-color 5000s ease-in-out 0s',
  }
}